/**
 * Roteamento da Home por perfil/departamento (rodada PIPELINE-FLUXO / PF4).
 *
 * Extraído de HomePage pra ficar testável sem DOM. Decide QUAL home o usuário
 * vê ao logar:
 *   - 'comercial'    → colaborador (não-admin) do dept comercial (HomeComercial)
 *   - 'orcamentista' → colaborador (não-admin) do dept orçamentista (HomeOrcamentista)
 *   - 'classico'     → todos os demais (admin, super-admin, outros depts)
 *
 * Regras:
 *   - Só vale com o CRM v2 LIGADO (crmV2On). Flag OFF → sempre clássico.
 *   - Admin/super-admin NUNCA caem nos homes de dept (veem o clássico + as
 *     abas do Comercial pelo menu).
 *   - Comercial VENCE orçamentista quando o usuário é dos dois depts (o
 *     orçamentista-puro é quem é SÓ do dept orçamentista — mesma lógica do
 *     backend `isOrcamentistaPuro`).
 */
export type HomeVariant = 'comercial' | 'orcamentista' | 'classico';

export interface HomeRoutingUser {
  isAdmin?: boolean;
  isSuperAdmin?: boolean;
  departments?: string[];
}

export function escolherHomeVariant(
  user: HomeRoutingUser | null | undefined,
  crmV2On: boolean,
): HomeVariant {
  if (!crmV2On) return 'classico';
  if (user?.isAdmin || user?.isSuperAdmin) return 'classico';
  const depts = user?.departments ?? [];
  if (depts.includes('comercial')) return 'comercial';
  if (depts.includes('orcamentista')) return 'orcamentista';
  return 'classico';
}
